module.exports = __webpack_public_path__ + "img/editor.de3c1966.svg";